import { Box, Typography } from "@mui/material";
import CreateRobotScreen from "../create";
import { COLOR } from "../../../../utils/colors";
import { useNavigate, useParams } from "react-router-dom";
import { showSuccessToast } from "../../../../utils/utils";
import EditRobotScreen from "../edit";

export default function EditRobotPage() {
  const navigate = useNavigate()
  const onCancel = () => {
    navigate('/config/robots', {
      replace: true
    })
  }

  const { id } = useParams()

  const onSubmit = () => {
    showSuccessToast('Robot updated successfully')
    navigate('/config/robots', {
      replace: true
    })
  }
  return (
    <Box sx={{ padding: '36px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', mb: '24px' }}>
        <Typography
          sx={{
            fontSize: '24px',
            fontWeight: 600,
            color: COLOR.neutral[900]
          }}
        >
          Edit Robot
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: COLOR.neutral[900],
            opacity: 0.6,
          }}
        >
          Fill in the details below to update the robot.
        </Typography>
      </Box>
      <EditRobotScreen robotId={id || ''} onCancel={onCancel} hideTitle onSubmit={onSubmit} />
    </Box>
  )
}